import type { CreatePaymentResponse } from '@/pages/app/checkout/types'
import { api } from '@/services/axios'

export interface Payer {
  NomeCompleto: string
  Email: string
  Telefone: string
  Descricao: string
  Valor: number
  CampanhaId: number
  TitulosComprados: number[]
  UsuarioId: number
}

export async function createPayment(
  data: Payer,
): Promise<CreatePaymentResponse> {
  console.log(data)
  const response = await api.post<CreatePaymentResponse>(
    'Pagamento/CriarPagamentoML',
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return response.data
}
